'use strict';
angular.module('appMarketplace')
    .controller('AcceptPrivacyPolicyCtrl', ['$scope', '$location', '$state', '$window', 'NotificationService',
        'UserService', 'NavigationService', 'UrlService',
        function ($scope, $location, $state, $window, NotificationService,
                  UserService, NavigationService, UrlService) {

            $scope.window = angular.element("#acceptPrivacyPolicyForm").kendoWindow({
                actions: [],
                modal: true,
                pinned: true,
                resizable: false,
                title: "Privacy Policy Acknowledgement",
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded();
                },
                deactivate: function () {
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            $scope.acceptPrivacyPolicy = function () {
                UserService.acceptPrivacyPolicy(
                    function successCallback() {
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.privacyPolicyAccepted = true;
                        });
                        $scope.window.close();
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        $scope.formErrors = [];
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors.push(error);
                        });
                    })
            };

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };
        }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/accept-privacy-policy-ctrl.js
// module id = 202
// module chunks = 32